import React from 'react';
import ComboTotalPage from './components/ComboTotalPage';

function ComboTotalErick() {
  return <ComboTotalPage paymentUrlOverride="https://pay.kiwify.com.br/yKYVFMc?afid=erick" />;
}

export default ComboTotalErick;
